import React from 'react';
import { getRenderCardOverrides } from '../../utils';
import dynamic from 'next/dynamic';
import { useProductCardElements } from '../../../ProductListWrapper/utils';
import { useListPresentationContextData } from '../../context/ListPresentationContext';
import useHandleClicks from '../../hooks/useHandleClicks';

const FeatureProductCards = dynamic(() =>
  import('./FeatureProductCards').then((mod) => mod.FeatureProductCards)
);
const CardFrameForCollection = dynamic(() =>
  import('../../../CardFrameCollection').then((mod) => mod.default)
);

export default function ProductCardRenderer() {
  const data = useListPresentationContextData();
  const {
    isMobile,
    itemCountTotal,
    iterableList,
    listPresentationConfig,
    cardFrameConfig,
    contentTypeConditions,
  } = data.state;
  const { getConfigsAndUtils } = data.utilities;
  const {
    numItemsToShow,
    oneGridCellGeometry,
    sectionColors,
    viewAllItemsConfig,
    containerTracks,
  } = getConfigsAndUtils().generalValues;
  const { onListItemClick } = useHandleClicks();

  const { isProductCardEnabled } = useProductCardElements();

  const listToRender = iterableList?.slice(
    0,
    viewAllItemsConfig?.areAllItemsVisible ? itemCountTotal : numItemsToShow
  );

  if (!listToRender?.length) {
    return null;
  }

  return listToRender.map((data, index) => {
    if (
      contentTypeConditions.featuredCollection ||
      contentTypeConditions.featuredTag ||
      contentTypeConditions.featuredCategory
    ) {
      const textColorOverride = getRenderCardOverrides({
        listPresentationConfig,
        sectionColors,
      });
      return (
        <FeatureProductCards
          key={index}
          isProductCardEnabled={isProductCardEnabled}
          data={data}
          index={index}
          oneGridCellGeometry={oneGridCellGeometry}
          isMobile={isMobile}
          sectionColorsOverrides={{ textColor: textColorOverride }}
          customClass={'!tw-h-auto !tw-w-min'}
        />
      );
    }
    return (
      <>
        <CardFrameForCollection
          key={index}
          itemConfig={data}
          itemIndex={index}
          containerTracks={containerTracks}
          cardFrameConfig={cardFrameConfig}
          oneGridCellGeometry={oneGridCellGeometry}
          openInNewTab={listPresentationConfig?.openInNewTab}
          isMobile={isMobile}
          onCollectionClick={onListItemClick}
          contentTypeConditions = {contentTypeConditions}
        />
      </>
    );
  });
}
